import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

const resourcePage = {
    department: "Mathematics",
    short: "mathematics",
    programmePath: "/programme/bsh/maths",
    description:
        "Access student resources for the Department of Mathematics including syllabus, timetable, academic calendar, question papers, add-on courses, publications, and mentor details.",
    sections: [
        {
            title: "IA Syllabus",
            items: [
                {
                    label: "IA Coverage",
                    href: "https://drive.google.com/file/d/1nv7jsd4BepFeiYRkGXYq4eZu28jX3ALK/view?usp=drive_link"
                }
            ],
        },
        // {
        //     title: "Timetable",
        //     items: [{ label: "Mathematics Timetable", href: "#" }],
        // },
        {
            title: "Academic Calendar",
            items: [
                {
                    label: "Calendar of Events",
                    href: "https://drive.google.com/file/d/1daygHO3VhNlNC8R3OGDOehTbisW1KMN7/view?usp=drive_link"
                }
            ],
        },
        // {
        //     title: "Lab Manuals",
        //     items: [{ label: "Mathematics Lab Manual / Tutorial Materials", href: "#" }],
        // },
        {
            title: "Question Papers & Solutions",
            items: [
                {
                    label: "Mathematics Question Papers and Solutions",
                    href: "https://drive.google.com/drive/folders/1oh6GSIV-GOUheG3J16cc3TFgwRhMx_t6?usp=drive_link"
                }
            ],
        },
        // {
        //     title: "Add-On Subjects",
        //     items: [{ label: "Mathematics Add-On Course Syllabus", href: "#" }],
        // },
        // {
        //     title: "Published Papers & Patents",
        //     items: [{ label: "Mathematics Published Papers / Patents", href: "#" }],
        // },
        {
            title: "Mentor List",
            items: [
                {
                    label: "Mentor List 2025-26",
                    href: "https://drive.google.com/file/d/1IfRQUtCD2p59R2Zf945kqLVnx3usvTu1/view?usp=drive_link"
                }
            ],
        },
    ],
};

const MathematicsResources = () => (
    <StudentResourceTemplate resourcePage={resourcePage} />
);

export default MathematicsResources;
